import React from "react";
import { NavLink } from "react-router-dom";
import Icon, { IconName } from "../icons/Icon";

const Sidebar = () => {
  const navItems: Array<{ label: string; to: string; icon: IconName }> = [
    {
      label: "Command Center",
      to: "/admin/v2/command-center",
      icon: "LayoutGrid",
    },
  ];

  return (
    <aside className="tw-flex tw-h-full tw-w-64 tw-flex-col tw-gap-6 tw-border-r tw-border-rbah-ink/10 tw-bg-white tw-p-6">
      <div className="tw-flex tw-items-center tw-gap-3">
        <div className="tw-flex tw-h-10 tw-w-10 tw-items-center tw-justify-center tw-rounded-rbah tw-bg-rbah-ink tw-text-rbah-off">
          <Icon name="Radar" className="tw-h-5 tw-w-5" />
        </div>
        <div>
          <p className="tw-text-xs tw-font-semibold tw-uppercase tw-tracking-[0.2em] tw-text-rbah-ink/60">
            RBAH
          </p>
          <p className="tw-text-base tw-font-bold tw-text-rbah-ink">Command Center</p>
        </div>
      </div>

      <nav className="tw-flex tw-flex-col tw-gap-2">
        {navItems.map((item) => (
          <NavLink
            key={item.label}
            to={item.to}
            className={({ isActive }) =>
              [
                "tw-flex tw-items-center tw-gap-3 tw-rounded-rbah tw-px-4 tw-py-3 tw-text-sm tw-font-semibold tw-transition",
                isActive
                  ? "tw-bg-rbah-ink tw-text-rbah-off"
                  : "tw-text-rbah-ink hover:tw-bg-rbah-off",
              ].join(" ")
            }
          >
            <Icon
              name={item.icon}
              className="tw-h-4 tw-w-4 tw-text-rbah-lime"
            />
            <span>{item.label}</span>
          </NavLink>
        ))}
      </nav>
    </aside>
  );
};

export default Sidebar;
